<script setup>
import { useHead } from '@vueuse/head';
import PanelContainer from '@/components/panels/PanelContainer.vue';
import AuthHeading from '@/views/auth/Partials/AuthHeading.vue';
import LayoutPlain from '@/views/_layouts/plain.vue';
import LinkNormal from '@/components/links/LinkNormal.vue';

defineProps({
  resource: {
    type: String,
    default: 'Not Found',
  },
});

useHead({
  title: '404',
  meta: [
    {
      name: 'description',
      content: 'File Not Found',
    },
  ],
});
</script>

<template>
  <LayoutPlain>
    <PanelContainer>
      <AuthHeading />

      <div class="mt-8 overflow-hidden border border-gray-200 bg-white p-6 text-center">
        <figure>
          <img
            class="aspect-video w-full object-cover"
            src="@images/empty-counter.png"
            alt=""
            width="430"
            height="287" />
          <figcaption>
            <h1 class="mt-6 text-xl font-bold">Oops, it seems we&rsquo;ve missed our connection.</h1>
            <p
              v-if="resource"
              class="mt-4 text-base">
              {{ resource }}
            </p>
            <p class="mt-4 text-base">
              <LinkNormal
                as="a"
                href="/">
                Go Home
              </LinkNormal>
            </p>
          </figcaption>
        </figure>
      </div>
    </PanelContainer>
  </LayoutPlain>
</template>
